import { observer } from 'mobx-react';
import React from 'react';
import { Alert, Form, FormFeedback, FormGroup, Input } from 'reactstrap';
import BusyButton from '~/components/BusyButton';
import ErrorList from '~/components/ErrorList';
import { EmailHelpText } from './EmailHelpText';
import { EmailHelpPopover } from './EmailHelpPopover';
import { LoginStore } from './LoginStore';
import PasswordInput from '~/components/PasswordInput';
import { getAppContext } from '~/lib/AppContext';
import { RegistrationRoute } from '~/lib/helper/RouteHelper';

interface LoginFormProps {
    store: LoginStore;
}

@observer
export class LoginForm extends React.Component<LoginFormProps> {
    render() {
        const { store } = this.props;
        const { loginForm } = store;
        return (
            <>
                {store.showLoggedOut && <Alert color="success">You've been logged out.</Alert>}
                <div className="preLoginTitle">
                    <h2>Log in to {getAppContext().config.brandName}</h2>
                    <p>Welcome back! Please enter your details.</p>
                </div>
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        void loginForm.doSubmit(() => store.doLogin(), { errorSummary: 'Unable to log in' });
                    }}
                >
                    <FormGroup className="mb-3">
                        <label className="form-label" htmlFor={loginForm.idFor('email')}>
                            Email address
                        </label>
                        <EmailHelpPopover />
                        <Input
                            id={loginForm.idFor('email')}
                            type="email"
                            autoComplete="username"
                            autoFocus
                            placeholder="Enter your email"
                            {...loginForm.inputProps('email')}
                        />
                        <FormFeedback>
                            <ErrorList errors={loginForm.errorsFor('email')} />
                        </FormFeedback>
                    </FormGroup>

                    <FormGroup className="mb-3">
                        <label className="form-label" htmlFor={loginForm.idFor('password')}>
                            Password
                        </label>
                        <PasswordInput
                            id={loginForm.idFor('password')}
                            autoComplete="current-password"
                            placeholder="Enter your password"
                            {...loginForm.inputProps('password')}
                        />
                        <ErrorList errors={loginForm.errorsFor('password')} />
                    </FormGroup>

                    <FormGroup check className="loginOptions mb-3">
                        <Input type="checkbox" id="keepSignedIn" {...loginForm.checkboxProps('noExpire')} />
                        <label className="form-check-label" htmlFor="keepSignedIn">
                            Keep me logged in until I close my browser
                        </label>
                    </FormGroup>

                    <div className="loginActions mb-3">
                        <BusyButton
                            type="submit"
                            busy={loginForm.isSubmitting}
                            color="primary"
                            size="lg"
                            className="w-100"
                        >
                            <i className="icon ion-md-lock me-2" />
                            Log in
                        </BusyButton>
                    </div>

                    <div className="forgotPassword text-muted">
                        <a href="/login/forgotpassword">Forgot password?</a>
                    </div>
                </Form>

                {store.hasFailedLogin && (
                    <div className="emailHelp text-muted">
                        <EmailHelpText />
                    </div>
                )}

                <div className="text-muted mt-3 text-center fs-0-9rem">
                    Don't have an account yet? <a href={RegistrationRoute}>Sign up now</a>.
                </div>
            </>
        );
    }
}
